import axios from "axios";
import { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import toast from "react-hot-toast";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [contact, setContact] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [contactmeta, setContactMeta] = useState();

  // ✅ Refs for inputs
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const subjectRef = useRef(null);
  const messageRef = useRef(null);
  const captchaRef = useRef(null);
  const captchaScrollRef = useRef(null);

  // ✅ Validation function
  const validateForm = () => {
    if (!formData.name.trim())
      return { field: "name", message: "Name is required." };
    if (!/^[A-Za-z\s]{2,50}$/.test(formData.name))
      return {
        field: "name",
        message: "Name must be 2–50 characters (letters and spaces only).",
      };

    if (!formData.email.trim())
      return { field: "email", message: "Email is required." };
    if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,24}$/.test(formData.email))
      return { field: "email", message: "Please enter a valid email address." };

    if (!formData.subject.trim())
      return { field: "subject", message: "Subject is required." };

    if (!formData.message.trim())
      return { field: "message", message: "Message is required." };

    // reCAPTCHA check
    if (!captchaToken) {
      return { field: "captcha", message: "Captcha is required." };
    }

    return null; // ✅ No errors
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const fetchContactData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getContactUsContent`
      );
      setContact(res.data.data);
    } catch (error) {}
  };

  // ✅ Send message API call
  const sendMessage = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationError = validateForm();
    if (validationError) {
      toast.error(validationError.message);

      let targetRef = null;

      if (validationError.field === "name") targetRef = nameRef;
      if (validationError.field === "email") targetRef = emailRef;
      if (validationError.field === "subject") targetRef = subjectRef;
      if (validationError.field === "message") targetRef = messageRef;
      if (validationError.field === "captcha") targetRef = captchaRef;

      if (targetRef?.current) {
        // Cursor move
        targetRef.current.focus();

        // Smooth scroll to field
        targetRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center", // center me scroll hoga
        });

        // Optional: thoda error highlight add karna
        targetRef.current.classList.add("error-focus");
        setTimeout(() => {
          targetRef.current.classList.remove("error-focus");
        }, 2000);
      }

      setLoading(false);
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/saveEnquiry`,
        { ...formData, captcha: captchaToken }
      );

      if (res.data.status === true) {
        toast.success(
          res.data.message || "Your message has been sent successfully!"
        );
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        setCaptchaToken(null);
        captchaScrollRef.current.reset();
      } else {
        toast.error(
          res.data.message || "Something went wrong. Please try again later."
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const fetchContactMetaData = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/getCmsContent`,
        {
          post_url: "contact",
        }
      );
      setContactMeta(res.data.data);
    } catch (err) {
      console.error("Error fetching cancellation policy:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    fetchContactData();
    fetchContactMetaData();
  }, []);

  return (
    <section className="ser_v_araeea faqess contactuss">
      <SetMetaTags
        title={contactmeta?.meta_title}
        description={contactmeta?.meta_description}
        keywords={contactmeta?.meta_keyword}
      />

      <div className="container">
        <div className="faq_contentss">
          <h2>Contact Us</h2>

          {/* Contact Info */}
          <div className="row">
            <div className="col-lg-4 col-sm-4">
              <div className="ads_contacts">
                <h3>Our Location</h3>
                <p>{contact.ourlocation}</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4">
              <div className="ads_contacts">
                <h3>Email</h3>
                <p>{contact.email}</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4">
              <div className="ads_contacts">
                <h3>Social Network</h3>
                <p>
                  {contact?.facebook && (
                    <a
                      href={contact?.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/facebooks_ic.png" alt="Facebook" />
                    </a>
                  )}
                  {contact?.instagram && (
                    <a
                      href={contact?.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/instagr_ic.png" alt="Instagram" />
                    </a>
                  )}
                  {contact?.youtube && (
                    <a
                      href={contact?.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-youtube-play"></i>
                    </a>
                  )}

                  {contact?.tiktok && (
                    <a
                      href={contact?.tiktok}
                      target="_blank"
                      className="tikks"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/tiktok.png" alt="TikTok" />
                    </a>
                  )}
                  {contact?.linkedin && (
                    <a
                      href={contact?.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-linkedin-square"></i>
                    </a>
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="contacus_formm">
            <h4>Get in Touch</h4>
            <form onSubmit={sendMessage}>
              <div className="row">
                <div className="col-lg-12 col-sm-6">
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      ref={nameRef}
                      type="text"
                      name="name"
                      className="form-control"
                      value={formData.name}
                      onKeyPress={(e) => {
                        if (!/^[A-Za-z\s]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      maxLength={50}
                      onChange={handleChange}
                      placeholder="Enter your name"
                    />
                  </div>
                </div>

                <div className="col-lg-12 col-sm-6">
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      ref={emailRef}
                      type="email"
                      name="email"
                      className="form-control"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                    />
                  </div>
                </div>

                <div className="col-lg-12 col-sm-6">
                  <div className="form-group">
                    <label>Subject</label>
                    <input
                      ref={subjectRef}
                      type="text"
                      name="subject"
                      className="form-control"
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="Enter subject"
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <label>Message</label>
                    <textarea
                      ref={messageRef}
                      name="message"
                      className="form-control"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Write your message"
                      rows="4"
                    ></textarea>
                  </div>
                </div>

                {/* CAPTCHA */}
                <div ref={captchaRef}>
                  <ReCAPTCHA
                    ref={captchaScrollRef}
                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                    onChange={(token) => setCaptchaToken(token)}
                  />
                </div>

                <div className="col-lg-12">
                  <div className="submmit">
                    <button type="submit" disabled={loading}>
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
